import { render, staticRenderFns } from "./subscribe.vue?vue&type=template&id=a2b39eb0&scoped=true"
import script from "./subscribe.vue?vue&type=script&lang=js"
export * from "./subscribe.vue?vue&type=script&lang=js"
import style0 from "./subscribe.vue?vue&type=style&index=0&id=a2b39eb0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b39eb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2b39eb0')) {
      api.createRecord('a2b39eb0', component.options)
    } else {
      api.reload('a2b39eb0', component.options)
    }
    module.hot.accept("./subscribe.vue?vue&type=template&id=a2b39eb0&scoped=true", function () {
      api.rerender('a2b39eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/news/subscribe.vue"
export default component.exports